{
  "generatedAt": "2026-07-25T20:47:12.590Z",
  "source": {
    "id": "kimi-k3-release",
    "title": "Kimi K3: Open Frontier Intelligence",
    "url": "https://www.kimi.com/blog/kimi-k3",
    "publishedAt": "2026-07-16"
  },
  "chartGroups": [
    {
      "id": "coding",
      "title": "Coding",
      "subtitle": "All maxed out on thinking effort: max or xhigh.",
      "benchmarkIds": [
        "deep-swe",
        "program-bench",
        "terminal-bench-2-1",
        "frontier-swe",
        "swe-marathon",
        "posttrain-bench",
        "mls-bench-lite",
        "kimi-code-bench-2"
      ]
    },
    {
      "id": "general-agents",
      "title": "General Agents",
      "subtitle": "All maxed out on thinking effort: max or xhigh.",
      "benchmarkIds": [
        "gdpval-aa-v2",
        "browsecomp",
        "deepsearchqa",
        "toolathlon-verified",
        "mcp-atlas",
        "automation-bench",
        "job-bench",
        "aa-briefcase",
        "apex-agents",
        "officeqa-pro",
        "spreadsheetbench-2",
        "deck-bench"
      ]
    },
    {
      "id": "reasoning",
      "title": "Reasoning & Knowledge",
      "subtitle": "All maxed out on thinking effort: max or xhigh.",
      "benchmarkIds": [
        "gpqa-diamond",
        "hle-full",
        "hle-full-tools"
      ]
    },
    {
      "id": "visual-agents",
      "title": "Visual Agents",
      "subtitle": "All maxed out on thinking effort: max or xhigh.",
      "benchmarkIds": [
        "mmmu-pro",
        "mmmu-pro-python",
        "charxiv-rq",
        "charxiv-rq-python",
        "mathvision",
        "mathvision-python",
        "babyvision-python",
        "zerobench-pass5",
        "zerobench-python-pass5",
        "worldvqa-forceanswer",
        "omnidocbench",
        "perceptionbench"
      ]
    },
    {
      "id": "knowledge-work",
      "title": "Internal Knowledge Work Bench",
      "subtitle": "All maxed out on thinking effort: max or xhigh.",
      "benchmarkIds": [
        "online-exp-bench",
        "deck-bench",
        "finance-bench"
      ],
      "pointLimit": 3
    }
  ],
  "benchmarks": [
    {
      "id": "deep-swe",
      "name": "DeepSWE",
      "shortName": "DeepSWE",
      "category": "Coding",
      "metric": "resolve rate",
      "unit": "%",
      "direction": "higher",
      "comment": "KimiCode",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 67.5,
          "displayValue": "67.5",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 70,
          "displayValue": "70.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 73,
          "displayValue": "73.0",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 59,
          "displayValue": "59.0",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 67,
          "displayValue": "67.0",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 46.2,
          "displayValue": "46.2",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "program-bench",
      "name": "Program Bench",
      "shortName": "Program Bench",
      "category": "Coding",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "KimiCode",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 77.8,
          "displayValue": "77.8",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 76.8,
          "displayValue": "76.8",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 77.6,
          "displayValue": "77.6",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 71.9,
          "displayValue": "71.9",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 70.8,
          "displayValue": "70.8",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 63.7,
          "displayValue": "63.7",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "terminal-bench-2-1",
      "name": "Terminal Bench 2.1",
      "shortName": "Terminal Bench 2.1",
      "category": "Coding",
      "metric": "resolve rate",
      "unit": "%",
      "direction": "higher",
      "comment": "KimiCode",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 88.3,
          "displayValue": "88.3",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 84.6,
          "displayValue": "84.6",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 88.8,
          "displayValue": "88.8",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 84.6,
          "displayValue": "84.6",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 83.4,
          "displayValue": "83.4",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 82.7,
          "displayValue": "82.7",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "frontier-swe",
      "name": "FrontierSWE",
      "shortName": "FrontierSWE",
      "category": "Coding",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "Dominance as of 26/7/16 · KimiCode",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 81.2,
          "displayValue": "81.2",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 86.6,
          "displayValue": "86.6",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 71.3,
          "displayValue": "71.3",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 66.7,
          "displayValue": "66.7",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 64.9,
          "displayValue": "64.9",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 67.3,
          "displayValue": "67.3",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "swe-marathon",
      "name": "SWE Marathon",
      "shortName": "SWE Marathon",
      "category": "Coding",
      "metric": "pass@1",
      "unit": "%",
      "direction": "higher",
      "comment": "Claude Code",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 42,
          "displayValue": "42.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 35,
          "displayValue": "35.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 39,
          "displayValue": "39.0",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 40,
          "displayValue": "40.0",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 14,
          "displayValue": "14.0",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 13,
          "displayValue": "13.0",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "posttrain-bench",
      "name": "PostTrain Bench",
      "shortName": "PostTrain Bench",
      "category": "Coding",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "Claude Code",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 36.6,
          "displayValue": "36.6",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 41.4,
          "displayValue": "41.4",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 34.6,
          "displayValue": "34.6",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 34.1,
          "displayValue": "34.1",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 28.4,
          "displayValue": "28.4",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 34.3,
          "displayValue": "34.3",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "mls-bench-lite",
      "name": "MLS Bench",
      "shortName": "MLS Bench",
      "category": "Coding",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "KimiCode",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 48.3,
          "displayValue": "48.3",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 49.9,
          "displayValue": "49.9",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 46.2,
          "displayValue": "46.2",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 42.8,
          "displayValue": "42.8",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 35.5,
          "displayValue": "35.5",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 40.4,
          "displayValue": "40.4",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "kimi-code-bench-2",
      "name": "Kimi Code Bench 2.0 (Internal)",
      "shortName": "Kimi Code Bench 2.0 (Internal)",
      "category": "Coding",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 72.9,
          "displayValue": "72.9",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 76.9,
          "displayValue": "76.9",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 64.8,
          "displayValue": "64.8",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 71.7,
          "displayValue": "71.7",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 69,
          "displayValue": "69.0",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 64.2,
          "displayValue": "64.2",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "gdpval-aa-v2",
      "name": "GDPval-AA v2 (Elo-score)",
      "shortName": "GDPval-AA v2",
      "category": "Agents",
      "metric": "Elo score",
      "unit": "Elo",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 1668,
          "displayValue": "1668",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 1760,
          "displayValue": "1760",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 1748,
          "displayValue": "1748",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 1600,
          "displayValue": "1600",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 1494,
          "displayValue": "1494",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 1514,
          "displayValue": "1514",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "browsecomp",
      "name": "BrowseComp",
      "shortName": "BrowseComp",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 91.2,
          "displayValue": "91.2",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 88,
          "displayValue": "88.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 90.4,
          "displayValue": "90.4",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 84.3,
          "displayValue": "84.3",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 84.4,
          "displayValue": "84.4",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "deepsearchqa",
      "name": "DeepSearchQA (f1-score)",
      "shortName": "DeepSearchQA",
      "category": "Agents",
      "metric": "F1 score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 95,
          "displayValue": "95.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 94.2,
          "displayValue": "94.2",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 93.1,
          "displayValue": "93.1",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "toolathlon-verified",
      "name": "Toolathlon-Verified",
      "shortName": "Toolathlon-Verified",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 73.2,
          "displayValue": "73.2",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 77.9,
          "displayValue": "77.9",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 74.9,
          "displayValue": "74.9",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 76.2,
          "displayValue": "76.2",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 73.5,
          "displayValue": "73.5",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 59.9,
          "displayValue": "59.9",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "mcp-atlas",
      "name": "MCP Atlas",
      "shortName": "MCP Atlas",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 84.2,
          "displayValue": "84.2",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 84.7,
          "displayValue": "84.7",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 83.6,
          "displayValue": "83.6",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 83.6,
          "displayValue": "83.6",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 82.8,
          "displayValue": "82.8",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 82.6,
          "displayValue": "82.6",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "automation-bench",
      "name": "Automation Bench",
      "shortName": "Automation Bench",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 30.8,
          "displayValue": "30.8",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 29.1,
          "displayValue": "29.1",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 29.7,
          "displayValue": "29.7",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 27.2,
          "displayValue": "27.2",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 22.7,
          "displayValue": "22.7",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 12.9,
          "displayValue": "12.9",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "job-bench",
      "name": "Job Bench",
      "shortName": "Job Bench",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 52.9,
          "displayValue": "52.9",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 57.4,
          "displayValue": "57.4",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 46.5,
          "displayValue": "46.5",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 48.4,
          "displayValue": "48.4",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 38.3,
          "displayValue": "38.3",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 43.4,
          "displayValue": "43.4",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "aa-briefcase",
      "name": "AA-Briefcase (Elo-score)",
      "shortName": "AA-Briefcase",
      "category": "Agents",
      "metric": "Elo score",
      "unit": "Elo",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 1548,
          "displayValue": "1548",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 1583,
          "displayValue": "1583",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 1495,
          "displayValue": "1495",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 1354,
          "displayValue": "1354",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 1158,
          "displayValue": "1158",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 1260,
          "displayValue": "1260",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "apex-agents",
      "name": "APEX-Agents",
      "shortName": "APEX-Agents",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 41,
          "displayValue": "41.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 43.3,
          "displayValue": "43.3",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 39.9,
          "displayValue": "39.9",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 39.4,
          "displayValue": "39.4",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 38.5,
          "displayValue": "38.5",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 35.6,
          "displayValue": "35.6",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "officeqa-pro",
      "name": "Office QA Pro",
      "shortName": "Office QA Pro",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 63.3,
          "displayValue": "63.3",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 69.9,
          "displayValue": "69.9*",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 63.2,
          "displayValue": "63.2*",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "opus-4-8",
          "value": 63.9,
          "displayValue": "63.9*",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "gpt-5-5",
          "value": 60.9,
          "displayValue": "60.9*",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "glm-5-2",
          "value": 41.4,
          "displayValue": "41.4",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "spreadsheetbench-2",
      "name": "SpreadsheetBench 2",
      "shortName": "SpreadsheetBench 2",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 34.8,
          "displayValue": "34.8",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 34.7,
          "displayValue": "34.7*",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 32.4,
          "displayValue": "32.4*",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "opus-4-8",
          "value": 31.55,
          "displayValue": "31.55*",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "gpt-5-5",
          "value": 29.05,
          "displayValue": "29.05*",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "glm-5-2",
          "value": 28.12,
          "displayValue": "28.12",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "deck-bench",
      "name": "DECK-Bench (Internal)",
      "shortName": "DECK-Bench (Internal)",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 73.5,
          "displayValue": "73.5",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 73,
          "displayValue": "73.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 74.7,
          "displayValue": "74.7",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 66.9,
          "displayValue": "66.9",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 68.2,
          "displayValue": "68.2",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 68.6,
          "displayValue": "68.6",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "gpqa-diamond",
      "name": "GPQA-Diamond",
      "shortName": "GPQA-Diamond",
      "category": "Reasoning",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 93.5,
          "displayValue": "93.5",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 92.6,
          "displayValue": "92.6",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 94.1,
          "displayValue": "94.1",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 91,
          "displayValue": "91.0",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 93.5,
          "displayValue": "93.5",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        },
        {
          "modelId": "glm-5-2",
          "value": 91.2,
          "displayValue": "91.2",
          "sourceLabel": "GLM-5.2 (max)",
          "note": ""
        }
      ]
    },
    {
      "id": "hle-full",
      "name": "HLE-Full",
      "shortName": "HLE-Full",
      "category": "Reasoning",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 43.5,
          "displayValue": "43.5",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 53.3,
          "displayValue": "53.3",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 44.5,
          "displayValue": "44.5",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 49.8,
          "displayValue": "49.8*",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "gpt-5-5",
          "value": 41.4,
          "displayValue": "41.4*",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": "The Kimi table marks this cited value with an asterisk."
        }
      ]
    },
    {
      "id": "hle-full-tools",
      "name": "HLE-Full w/ tools",
      "shortName": "HLE-Full w/ tools",
      "category": "Reasoning",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 56,
          "displayValue": "56.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 63,
          "displayValue": "63.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 58,
          "displayValue": "58.0",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 57.9,
          "displayValue": "57.9*",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": "The Kimi table marks this cited value with an asterisk."
        },
        {
          "modelId": "gpt-5-5",
          "value": 52.2,
          "displayValue": "52.2*",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": "The Kimi table marks this cited value with an asterisk."
        }
      ]
    },
    {
      "id": "mmmu-pro",
      "name": "MMMU-Pro",
      "shortName": "MMMU-Pro",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 81.6,
          "displayValue": "81.6",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 81.2,
          "displayValue": "81.2",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 83,
          "displayValue": "83.0",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 78.9,
          "displayValue": "78.9",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 81.2,
          "displayValue": "81.2",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "mmmu-pro-python",
      "name": "MMMU-Pro w/ python",
      "shortName": "MMMU-Pro w/ python",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 83.4,
          "displayValue": "83.4",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 86.5,
          "displayValue": "86.5",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 84.6,
          "displayValue": "84.6",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 82.7,
          "displayValue": "82.7",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 83.2,
          "displayValue": "83.2",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "charxiv-rq",
      "name": "CharXiv (RQ)",
      "shortName": "CharXiv (RQ)",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 84.8,
          "displayValue": "84.8",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 88.9,
          "displayValue": "88.9",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 84.6,
          "displayValue": "84.6",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 80.5,
          "displayValue": "80.5",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 84.1,
          "displayValue": "84.1",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "charxiv-rq-python",
      "name": "CharXiv (RQ) w/ python",
      "shortName": "CharXiv (RQ) w/ python",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 91.3,
          "displayValue": "91.3",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 93.5,
          "displayValue": "93.5",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 89.1,
          "displayValue": "89.1",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 89.9,
          "displayValue": "89.9",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 89,
          "displayValue": "89.0",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "mathvision",
      "name": "MathVision",
      "shortName": "MathVision",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 94.3,
          "displayValue": "94.3",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 94.8,
          "displayValue": "94.8",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 95.8,
          "displayValue": "95.8",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 86.7,
          "displayValue": "86.7",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 92.2,
          "displayValue": "92.2",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "mathvision-python",
      "name": "MathVision w/ python",
      "shortName": "MathVision w/ python",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 97.8,
          "displayValue": "97.8",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 98.6,
          "displayValue": "98.6",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 97.8,
          "displayValue": "97.8",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 97.1,
          "displayValue": "97.1",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 96.8,
          "displayValue": "96.8",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "babyvision-python",
      "name": "BabyVision w/ python",
      "shortName": "BabyVision w/ python",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 85.7,
          "displayValue": "85.7",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 90.5,
          "displayValue": "90.5",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 88.9,
          "displayValue": "88.9",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 81.2,
          "displayValue": "81.2",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 83.6,
          "displayValue": "83.6",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "zerobench-pass5",
      "name": "ZeroBench_main (pass@5)",
      "shortName": "ZeroBench (pass@5)",
      "category": "Vision",
      "metric": "pass@5",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 23,
          "displayValue": "23.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 23,
          "displayValue": "23.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 17,
          "displayValue": "17.0",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 17,
          "displayValue": "17.0",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 22,
          "displayValue": "22.0",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "zerobench-python-pass5",
      "name": "ZeroBench_main w/ python (pass@5)",
      "shortName": "ZeroBench w/ python (pass@5)",
      "category": "Vision",
      "metric": "pass@5",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 41,
          "displayValue": "41.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 46,
          "displayValue": "46.0",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 35,
          "displayValue": "35.0",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 34,
          "displayValue": "34.0",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 41,
          "displayValue": "41.0",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "worldvqa-forceanswer",
      "name": "WorldVQA ForceAnswer",
      "shortName": "WorldVQA ForceAnswer",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 51,
          "displayValue": "51.0",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 56.7,
          "displayValue": "56.7",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 41.8,
          "displayValue": "41.8",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 39.1,
          "displayValue": "39.1",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 38.5,
          "displayValue": "38.5",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "omnidocbench",
      "name": "OmniDocBench",
      "shortName": "OmniDocBench",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 91.1,
          "displayValue": "91.1",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 89.8,
          "displayValue": "89.8",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 85.8,
          "displayValue": "85.8",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 87.9,
          "displayValue": "87.9",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 89.4,
          "displayValue": "89.4",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "perceptionbench",
      "name": "PerceptionBench",
      "shortName": "PerceptionBench",
      "category": "Vision",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 58.5,
          "displayValue": "58.5",
          "sourceLabel": "Kimi K3 (max)",
          "note": ""
        },
        {
          "modelId": "fable-5",
          "value": 57.2,
          "displayValue": "57.2",
          "sourceLabel": "Claude Fable 5 (max, with fallback)",
          "note": ""
        },
        {
          "modelId": "gpt-5-6-sol",
          "value": 59.7,
          "displayValue": "59.7",
          "sourceLabel": "GPT 5.6 Sol (max)",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 47.2,
          "displayValue": "47.2",
          "sourceLabel": "Claude Opus 4.8 (max)",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 55.8,
          "displayValue": "55.8",
          "sourceLabel": "GPT 5.5 (xhigh)",
          "note": ""
        }
      ]
    },
    {
      "id": "online-exp-bench",
      "name": "Online Exp Bench",
      "shortName": "Online Exp Bench",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "Internal Knowledge Work Bench",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 75.5,
          "displayValue": "75.5",
          "sourceLabel": "Kimi K3",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 70.6,
          "displayValue": "70.6",
          "sourceLabel": "GPT 5.5",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 65.9,
          "displayValue": "65.9",
          "sourceLabel": "Claude Opus 4.8",
          "note": ""
        }
      ]
    },
    {
      "id": "finance-bench",
      "name": "Finance-Bench",
      "shortName": "Finance-Bench",
      "category": "Agents",
      "metric": "score",
      "unit": "%",
      "direction": "higher",
      "comment": "Internal Knowledge Work Bench",
      "points": [
        {
          "modelId": "kimi-k3",
          "value": 62.6,
          "displayValue": "62.6",
          "sourceLabel": "Kimi K3",
          "note": ""
        },
        {
          "modelId": "opus-4-8",
          "value": 60.7,
          "displayValue": "60.7",
          "sourceLabel": "Claude Opus 4.8",
          "note": ""
        },
        {
          "modelId": "gpt-5-5",
          "value": 58.4,
          "displayValue": "58.4",
          "sourceLabel": "GPT 5.5",
          "note": ""
        }
      ]
    }
  ]
}
